import axios from '../../../api';

// This api call fetches deliveryOverviewdata
export async function fetchDeliveryData(userId, rejectWithValue) {
  try {
    return await axios.get(`/api/v1/riders/${userId}/orders_history`);
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}
